(function () {
    'use strict';

    function applyForProjectsController(sessionData, milestones, milestoneModalService) {
        var vm = this;
        vm.sessionData = sessionData;
        vm.results = [];

        milestoneModalService.getMilestonesAndTemplates(milestones).then(function (milestonesAndTemplates) {
            if (milestonesAndTemplates.length > 0) {
                milestoneModalService.openModal(milestonesAndTemplates);
            }
        });
    }

    applyForProjectsController.$inject = ['sessionData','milestones', 'milestoneModalService'];

    angular.module('ecap.dashboards').controller('applyForProjectsController', applyForProjectsController);
})();
